import { _ } from '/@/locale';
import type { HistoricalWeather } from '/@/types/weather/forecast';
import CropMonitoringResultGraphic from '/@/views/fields/field-monitoring/report/components/report-graphics/common';
import GDUGraphic from '../gdu-graphic';

export default function GDUCard({
    cropMonitoring,
    historicalWeather,
    isPdf,
    isMobile,
    isDesktopSm,
    showOnlyGraphic = false,
}: {
    cropMonitoring: any;
    historicalWeather: HistoricalWeather;
    isPdf: boolean;
    isMobile?: boolean;
    isDesktopSm?: boolean;
    showOnlyGraphic?: boolean;
}) {
    if (!cropMonitoring?.cornCropMonitoring?.id) return null;

    if (showOnlyGraphic && historicalWeather && cropMonitoring) {
        return (
            <GDUGraphic
                cropMonitoring={cropMonitoring}
                historicalWeather={historicalWeather}
                isPdf={isPdf}
                isMobile={isMobile}
                isDesktopSm={isDesktopSm}
            />
        );
    }

    return (
        <CropMonitoringResultGraphic
            title={_('Avance de GDUs y estadio vegetativo')}
            description={_('Evolución diaria de GDUs y estado del cultivo')}
            references={[
                { color: '#00BCFF', label: 'GDU' },
                { color: '#89D329', label: 'Estado Vegetativo' },
            ]}
        >
            {historicalWeather && cropMonitoring && (
                <GDUGraphic
                    cropMonitoring={cropMonitoring}
                    historicalWeather={historicalWeather}
                    isPdf={isPdf}
                    isMobile={isMobile}
                    isDesktopSm={isDesktopSm}
                />
            )}
        </CropMonitoringResultGraphic>
    );
}
